export default function Sidebar() {
  return (
    <div className="tw-hidden tw-text-sidebar-foreground xl:tw-block tw-w-[15rem]">
      <div className="tw-relative tw-h-svh tw-w-[15rem] tw-bg-transparent tw-transition-[width] tw-duration-200 tw-ease-linear ">
        <div className="tw-fixed tw-w-[15rem] tw-inset-y-0 z-10 tw-hidden tw-transition-[left,right,width] tw-duration-200 tw-ease-linear md:tw-flex tw-left-0 tw-top-[110px] tw-h-[100dvh-110px] tw-bg-[url(https://res.cloudinary.com/dhssqbwnq/image/upload/v1737523939/bwk1gqo9vihvxgkax56p.png)] tw-bg-cover tw-bg-no-repeat">
          <div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-bg-sidebar">
            <div className="tw-flex-col tw-gap-2 tw-p-2 tw-flex tw-items-center">
              <a className="tw-flex tw-flex-col tw-items-center" href="/">
                <span className="tw-relative tw-flex tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-size-14">
                  <span className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full tw-bg-muted">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#CCB221"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-user"
                    >
                      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </span>
                </span>
                <p className="tw-truncate tw-text-sm tw-font-semibold !tw-text-black">
                  Chưa có tài khoản?
                </p>
                <button className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50 [&_svg]:tw-pointer-events-none [&_svg]:tw-size-4 [&_svg]:tw-shrink-0 tw-bg-primary tw-shadow tw-px-4 tw-py-2 btn-led tw-relative tw-h-10 tw-w-48 tw-rounded tw-bg-[linear-gradient(90deg,_#FFDE29_0%,_#FFF17A_18.5%,_#FFDE29_38%,_#FFD852_58%,_#FFF17A_75.5%,_#FFDE29_88%,_#FE7_100%)] tw-font-bold !tw-text-black hover:tw-bg-[#fff129]">
                  Đăng ký ngay
                </button>
              </a>
            </div>

            <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-2 tw-overflow-auto scrollbar-custom tw-mt-2">
              <div class="tw-relative tw-flex tw-w-full tw-min-w-0 tw-flex-col tw-p-2">
                <div className="tw-w-full tw-text-sm">
                  <ul className="tw-w-full tw-min-w-0 tw-flex-col tw-flex tw-gap-2">
                    <li className="tw-relative">
                      <a
                        className="!tw-flex !tw-w-full !tw-items-center !tw-gap-2 !tw-overflow-hidden !tw-rounded-md !tw-p-2 !tw-text-left !tw-outline-none !tw-ring-sidebar-ring !tw-transition-[width,height,padding] focus-visible:!tw-ring-2 active:!tw-bg-sidebar-accent active:!tw-text-sidebar-accent-foreground disabled:!tw-pointer-events-none disabled:!tw-opacity-50 !-has-[[data-sidebar=menu-action]]/menu-item:!tw-pr-8 aria-disabled:!tw-pointer-events-none aria-disabled:!tw-opacity-50 data-[active=true]:!tw-bg-sidebar-accent data-[active=true]:!tw-font-medium data-[active=true]:!tw-text-sidebar-accent-foreground data-[state=open]:hover:!tw-bg-sidebar-accent data-[state=open]:hover:!tw-text-sidebar-accent-foreground  [&>svg]:!tw-size-4 [&>svg]:!tw-shrink-0 hover:!tw-bg-sidebar-accent hover:!tw-text-sidebar-accent-foreground !tw-text-sm !tw-h-10 !tw-bg-[#FFFCEA] dark:!tw-bg-transpgrouparent [&>svg]:!tw-size-5 !tw-text-[#CCB221] dark:!tw-text-[#FFDE29]"
                        href="/"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-house"
                        >
                          <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                          <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        </svg>
                        <span className="tw-text-base tw-font-semibold">
                          Trang chủ
                        </span>
                      </a>
                    </li>
                    <li className="tw-relative">
                      <a
                        className="!tw-flex !tw-w-full !tw-items-center !tw-gap-2 !tw-overflow-hidden !tw-rounded-md !tw-p-2 !tw-text-left !tw-outline-none !tw-ring-sidebar-ring !tw-transition-[width,height,padding] focus-visible:!tw-ring-2 hover:!tw-bg-[#f4f4f5] hover:!tw-text-sidebar-accent-foreground !tw-text-sm !tw-h-10 !tw-text-black"
                        href="/"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-calendar-days"
                        >
                          <path d="M8 2v4"></path>
                          <path d="M16 2v4"></path>
                          <rect
                            width="18"
                            height="18"
                            x="3"
                            y="4"
                            rx="2"
                          ></rect>
                          <path d="M3 10h18"></path>
                          <path d="M8 14h.01"></path>
                          <path d="M12 14h.01"></path>
                          <path d="M16 14h.01"></path>
                          <path d="M8 18h.01"></path>
                          <path d="M12 18h.01"></path>
                          <path d="M16 18h.01"></path>
                        </svg>
                        <span className="tw-text-base tw-font-semibold">
                          Lịch thi đấu
                        </span>
                      </a>
                    </li>
                    <li className="tw-relative">
                      <a
                        className="!tw-flex !tw-w-full !tw-items-center !tw-gap-2 !tw-overflow-hidden !tw-rounded-md !tw-p-2 !tw-text-left !tw-outline-none !tw-ring-sidebar-ring !tw-transition-[width,height,padding] focus-visible:!tw-ring-2 hover:!tw-bg-[#f4f4f5] hover:!tw-text-sidebar-accent-foreground !tw-text-sm !tw-h-10 !tw-text-black"
                        href="/"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-ticket-percent"
                        >
                          <path d="M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
                          <path d="M9 9h.01"></path>
                          <path d="m15 9-6 6"></path>
                          <path d="M15 15h.01"></path>
                        </svg>
                        <span className="tw-text-base tw-font-semibold">
                          Khuyến mãi
                        </span>
                      </a>
                    </li>
                    <li className="tw-relative">
                      <a
                        className="!tw-flex !tw-w-full !tw-items-center !tw-gap-2 !tw-overflow-hidden !tw-rounded-md !tw-p-2 !tw-text-left !tw-outline-none !tw-ring-sidebar-ring !tw-transition-[width,height,padding] focus-visible:!tw-ring-2 hover:!tw-bg-[#f4f4f5] hover:!tw-text-sidebar-accent-foreground !tw-text-sm !tw-h-10 !tw-text-black"
                        href="/"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-id-card"
                        >
                          <path d="M16 10h2"></path>
                          <path d="M16 14h2"></path>
                          <path d="M6.17 15a3 3 0 0 1 5.66 0"></path>
                          <circle cx="9" cy="11" r="2"></circle>
                          <rect
                            x="2"
                            y="5"
                            width="20"
                            height="14"
                            rx="2"
                          ></rect>
                        </svg>
                        <span className="tw-text-base tw-font-semibold">
                          Ứng tuyển BLV
                        </span>
                      </a>
                    </li>
                    <li className="tw-relative">
                      <a
                        className="!tw-flex !tw-w-full !tw-items-center !tw-gap-2 !tw-overflow-hidden !tw-rounded-md !tw-p-2 !tw-text-left !tw-outline-none !tw-ring-sidebar-ring !tw-transition-[width,height,padding] focus-visible:!tw-ring-2 hover:!tw-bg-[#f4f4f5] hover:!tw-text-sidebar-accent-foreground !tw-text-sm !tw-h-10 !tw-text-black"
                        href="/"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-gamepad2"
                        >
                          <line x1="6" x2="10" y1="11" y2="11"></line>
                          <line x1="8" x2="8" y1="9" y2="13"></line>
                          <line x1="15" x2="15.01" y1="12" y2="12"></line>
                          <line x1="18" x2="18.01" y1="10" y2="10"></line>
                          <path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"></path>
                        </svg>
                        <span className="tw-text-base tw-font-semibold">
                          Game +
                        </span>
                      </a>
                    </li>
                    <li className="tw-relative">
                      <a
                        className="!tw-flex !tw-w-full !tw-items-center !tw-gap-2 !tw-overflow-hidden !tw-rounded-md !tw-p-2 !tw-text-left !tw-outline-none !tw-ring-sidebar-ring !tw-transition-[width,height,padding] focus-visible:!tw-ring-2 hover:!tw-bg-[#f4f4f5] hover:!tw-text-sidebar-accent-foreground !tw-text-sm !tw-h-10 !tw-text-black"
                        href="/"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-cloud-download"
                        >
                          <path d="M12 13v8l-4-4"></path>
                          <path d="m12 21 4-4"></path>
                          <path d="M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284"></path>
                        </svg>
                        <div className="tw-relative">
                          <span className="tw-text-base tw-font-semibold">
                            Tải App
                          </span>
                          <img
                            className="tw-absolute tw-right-0 tw-top-0 -tw-translate-y-[40%] tw-translate-x-[100%]"
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAXCAYAAACMLIalAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATISURBVHgBzVZdaBxVFP7uzM7uZje7m+avSbMJTW1NrSUIwfYh+FCr+FB9qVgJiBYFX2xRpKK+KIg+VCtFRAsVmyAWahDfjVRTQUSMYgttEo1YSJpfk+wm2d3ZnZ25fvfOJmkS2yc39sDh/p0557vfOffOBW4huc/Q6vSgE/+DGLdaCFdhiov9bg9O4E6S4jncoEpqFzZRjNstCg8FuOy4OJM5jUZsktwWlOegVtJCFpEIhvAiNknE+gl5EjFy4hXSaObioGilUZwAL2PEMvF4wYMbOoarKKNsYKpg4SPkUDAdHIcDlTqI/Qotmgs2HhUOXkKZJbBhpogj9jwcw8AzBAJDVZKjUxhi+44UGEaZZQMoWYAtJJ4lHogItZqpG+B8pmQgFNTyyob0SQfXpKNbiCZ9AuFe9sdKydY4yiwroLKv4gv5JoJk6pJXIDtUs4ELafan/bFSmccPKLPo00cwRnYRC0XgIVPiAc6+q1Yih3wL+yIBZVe+mWMC5/BfiECGvvot4JPQ6dUTrUGljuFJ08MFdkeoUasZjcUJgjroG6l+/grKKgRyqvJjvKL6utANG0elX747zUrAqiMQVTmL1DCNorwqzDVswbbC+DvAC2xiBskqCZYeZvjDzKVtJMwicvEoZMjURSldF3I8AzMs4EUVDyqYp9tCCthGs7CFE0vPYaryU5zSoKSNu5eDhfdwzDoK1nLAkwd1Aq8RWNx348z7dost29H2Rhe+eex9NOUXMMfTmew+gpHzPyPSuRXJ9jhrMEsGcjBCecxdnUFuPI3kw0QAdZSXoO6f4W5gtJdsMJ4r8fpABz7wQeVRr8AHqsha0Q9qkiHJMW8n7UNw3ooRFIte8kI1qhLarvWJfUjxI8EjE0yEYQQCqG7fih9f6MPMTxPaZtfRbdjRVY3vn57EwGvAwS9jGOuTGD7rc7anXhOjpLqtBTs1qPQCZCzIoArAwk2JVunLU5lSd4jr3I3JjZIAGLGoNml6ZK/esRXx/1i84yDYzTJdHSyDSvpdjJjIjBaQIPAGbiwYF7CnJO5ivynm23t5P6RnoFaDuj6Pyb1xxDwFqIKoYz4QpPwKlLQKkxhBhtwcx1QkYkgPTeLS4TOo4HqiI4l93YfhZhzt/N7j7XBnF5Cx+FfvrMTEt1MIMv8OgwermVTWbJ16gdhYcxtf/B1SJRgH4qiqMXDAYrBQjWKBk1v8D5SKJV9dOsz9xZZxpxNbkB1NQ/x2He1Mcy4chhMJYqTnCoQpEKq2YMZMCJbB0p+LGPpwDA2Oizz/U7JJYOzrImrIeEjqX5jWqRRk/zDe05z3JslPDL/eX4HdMTIV3UHjFgKxSock5zO0MMhEpfwd3eA4x7VGBo1yaylerLMEG2SKAvS6qAKVKDA4TtBXPcvD5jfj/Ja40RJZfabw9SF7B/HHyzbaVp4uZ3fhvkgA391joCqpHLEWAkyZSUceHRUmGcRDWWQuD9k3BjFr46m3gPNr3lPdu7Gd0C9USOxXGQwvb1bq+l3ZuW7lauuV+hvUW9eum+d3kkDEtI1ZTj3/NvCV8i/+Dfm5NjxIFIe4WqeDqytQsbTszCsV53Lf9VuvFNAt3Y16rA6Hd9O6snVLwPSjCL+wVD8/qf+yvvwDJX4DSwu3deAAAAAASUVORK5CYII="
                            alt=""
                          />
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="tw-relative tw-flex tw-w-full tw-min-w-0 tw-flex-col tw-p-0">
                <div className="tw-w-full tw-text-sm">
                  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
                    <svg
                      height="160"
                      width="160"
                      viewBox="0 0 25 25"
                      role="img"
                    >
                      <path
                        fill="#FFFFFF"
                        d="M0,0 h25v25H0z"
                        shape-rendering="crispEdges"
                      ></path>
                      <path
                        fill="#000000"
                        d="M0 0h7v1H0zM8 0h1v1H8zM10 0h3v1H10zM14 0h1v1H14zM16 0h1v1H16zM18,0 h7v1H18zM0 1h1v1H0zM6 1h1v1H6zM8 1h2v1H8zM11 1h1v1H11zM18 1h1v1H18zM24,1 h1v1H24zM0 2h1v1H0zM2 2h3v1H2zM6 2h1v1H6zM8 2h1v1H8zM10 2h1v1H10zM12 2h2v1H12zM16 2h1v1H16zM18 2h1v1H18zM20 2h3v1H20zM24,2 h1v1H24zM0 3h1v1H0zM2 3h3v1H2zM6 3h1v1H6zM10 3h1v1H10zM12 3h2v1H12zM18 3h1v1H18zM20 3h3v1H20zM24,3 h1v1H24zM0 4h1v1H0zM2 4h3v1H2zM6 4h1v1H6zM8 4h5v1H8zM14 4h1v1H14zM18 4h1v1H18zM20 4h3v1H20zM24,4 h1v1H24zM0 5h1v1H0zM6 5h1v1H6zM9 5h4v1H9zM16 5h1v1H16zM18 5h1v1H18zM24,5 h1v1H24zM0 6h7v1H0zM8 6h1v1H8zM10 6h1v1H10zM12 6h1v1H12zM14 6h1v1H14zM16 6h1v1H16zM18,6 h7v1H18zM9 7h1v1H9zM11 7h3v1H11zM15 7h2v1H15zM0 8h1v1H0zM3 8h7v1H3zM14 8h1v1H14zM16 8h2v1H16zM20 8h1v1H20zM22,8 h3v1H22zM1 9h3v1H1zM5 9h1v1H5zM7 9h1v1H7zM9 9h1v1H9zM11 9h1v1H11zM15 9h1v1H15zM17 9h1v1H17zM19 9h5v1H19zM1 10h1v1H1zM5 10h2v1H5zM8 10h2v1H8zM12 10h1v1H12zM14 10h3v1H14zM18 10h1v1H18zM20 10h2v1H20zM24,10 h1v1H24zM0 11h2v1H0zM3 11h1v1H3zM7 11h3v1H7zM15 11h1v1H15zM18,11 h7v1H18zM1 12h1v1H1zM3 12h1v1H3zM6 12h1v1H6zM9 12h3v1H9zM16 12h1v1H16zM18 12h2v1H18zM24,12 h1v1H24zM0 13h1v1H0zM3 13h3v1H3zM7 13h1v1H7zM9 13h1v1H9zM12 13h2v1H12zM15 13h2v1H15zM20 13h1v1H20zM23 13h1v1H23zM0 14h3v1H0zM6 14h2v1H6zM9 14h1v1H9zM13 14h1v1H13zM15 14h1v1H15zM17 14h1v1H17zM20,14 h5v1H20zM0 15h1v1H0zM2 15h2v1H2zM5 15h1v1H5zM7 15h1v1H7zM9 15h1v1H9zM12 15h1v1H12zM14 15h4v1H14zM19 15h1v1H19zM21 15h2v1H21zM24,15 h1v1H24zM0 16h1v1H0zM3 16h4v1H3zM8 16h2v1H8zM11 16h10v1H11zM22 16h2v1H22zM8 17h4v1H8zM13 17h1v1H13zM15 17h2v1H15zM20 17h1v1H20zM22 17h2v1H22zM0 18h7v1H0zM8 18h1v1H8zM12 18h1v1H12zM16 18h1v1H16zM18 18h1v1H18zM20 18h1v1H20zM24,18 h1v1H24zM0 19h1v1H0zM6 19h1v1H6zM8 19h1v1H8zM11 19h1v1H11zM13 19h1v1H13zM15 19h2v1H15zM20 19h1v1H20zM0 20h1v1H0zM2 20h3v1H2zM6 20h1v1H6zM8 20h2v1H8zM11 20h1v1H11zM13 20h1v1H13zM15 20h6v1H15zM23,20 h2v1H23zM0 21h1v1H0zM2 21h3v1H2zM6 21h1v1H6zM8 21h2v1H8zM12 21h4v1H12zM17 21h2v1H17zM23,21 h2v1H23zM0 22h1v1H0zM2 22h3v1H2zM6 22h1v1H6zM10 22h2v1H10zM13 22h1v1H13zM17 22h1v1H17zM20,22 h5v1H20zM0 23h1v1H0zM6 23h1v1H6zM10 23h4v1H10zM19 23h2v1H19zM22,23 h3v1H22zM0 24h7v1H0zM8 24h6v1H8zM16 24h2v1H16zM21 24h1v1H21zM24,24 h1v1H24z"
                        shape-rendering="crispEdges"
                      ></path>
                    </svg>
                    <p className="tw-mt-2 !tw-text-black">
                      Quét mã QR để{" "}
                      <span className="tw-font-medium tw-text-[#CCB221]">
                        <a href="/" target="_blank">
                          Tải APP
                        </a>
                      </span>
                    </p>
                  </div>

                  <div className="tw-mt-4">
                    <img
                      src="https://res.cloudinary.com/dhssqbwnq/image/upload/v1737525319/pf8o6wb14dphdbfcrv5y.png"
                      alt="Văn Quyến LuongSon TV"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
